/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_OrganiseInputs */

const en_editor_organise = /** @type {(inputs: Editor_OrganiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organise`)
};

const de_editor_organise = /** @type {(inputs: Editor_OrganiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einordnen`)
};

/**
* | output |
* | --- |
* | "Organise" |
*
* @param {Editor_OrganiseInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_organise = /** @type {((inputs?: Editor_OrganiseInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_OrganiseInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_organise(inputs)
	return en_editor_organise(inputs)
});